import { PrivateBetaScreen } from './PrivateBetaScreen';

export const Analytics = () => {
  return (
    <PrivateBetaScreen
      icon="i-heroicons:chart-bar"
      title="Track your app's performance"
      description="Monitor user interactions, page views, and conversion metrics to understand how your app is being used."
    />
  );
};
